import { Dispatch, FC, SetStateAction, memo, useRef, useState } from 'react'
import { ReactComponent as FilterIcon } from 'assets/common/filter-field.svg'
import { useOnClickOutside } from 'usehooks-ts'
import { FlexCenter, themeValue } from 'styles'
import { Button, Stack, styled } from '@mui/material'
import { transientOptions } from 'styles/TransientOptions'
import Iconfont from 'components/Iconfont'

const StyledFilterIcon = styled(FilterIcon)`
  color: #626d74;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`

const FilterWrap = styled(FlexCenter)`
  position: relative;
  height: 100%;
  svg {
    cursor: pointer;
  }
`
const FilterDropdown = styled('div')`
  padding: 12px 24px;
  position: absolute;
  top: 100%;
  right: -20px;
  background-color: ${() => themeValue('rgba(30, 35, 41, 1)', '#fff')};
  border-radius: 0 0 4px 4px;
  box-shadow: ${() =>
    themeValue(
      '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
      '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
    )};
  min-width: 180px;
  z-index: 10;
`
const Title = styled('div')`
  font-size: 12px;
  line-height: 18px;
  color: ${(props) => props.theme.color.text60};
`

const CheckWrap = styled(Button)`
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
  padding: 0px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  &:hover {
    opacity: 0.8;
    background-color: unset;
    .checkbox-border {
      border: 1px solid ${({ theme }) => theme.color.primary30};
    }
  }
`
const CheckBoxPair = styled(Stack, transientOptions)<{
  $checked?: boolean
}>`
  width: 13px;
  height: 13px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  color: ${({ theme, $checked }) =>
    $checked ? theme.color.primary30 : 'rgb(95, 121, 140)'};
  border: 1px solid
    ${({ theme, $checked }) =>
      $checked ? theme.color.primary30 : 'rgb(95, 121, 140)'};
  input {
    position: absolute;
    z-index: -1;
    width: 1px;
    height: 1px;
  }
`
const CheckLabel = styled('div')`
  user-select: none;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  font-weight: normal;
  color: rgb(229, 234, 238);
`

const Wrap = styled('div')`
  display: flex;
  flex-direction: column;
  /* justify-content: flex-start; */
  align-items: flex-start;
`
export const FieldFilter: FC<{
  selected: string[]
  onChange: Dispatch<SetStateAction<string[]>>
  options: {
    label: string
    value: string
  }[]
}> = memo(({ selected, onChange, options }) => {
  const [show, setShow] = useState(false)

  const dropdownRef = useRef(null)

  const clickHandler = () => {
    setShow(!show)
  }
  useOnClickOutside(dropdownRef, () => {
    setShow(false)
  })

  const changeHandler = (current: string, c: boolean) => {
    if (c) {
      onChange([...selected, current])
    } else {
      onChange(selected.filter((val) => val !== current))
    }
  }

  return (
    <FilterWrap ref={dropdownRef}>
      <StyledFilterIcon onClick={clickHandler} />
      {show && (
        <FilterDropdown>
          <Title>Setting</Title>
          <Wrap>
            {options.map((option) => (
              <CheckWrap
                onClick={() =>
                  changeHandler(option.value, !selected.includes(option.value))
                }
              >
                <CheckBoxPair
                  $checked={selected.includes(option.value)}
                  className="checkbox-border"
                >
                  <input type="checkbox" />
                  {selected.includes(option.value) && (
                    <Iconfont name="icon-check-fill" size={12} />
                  )}
                </CheckBoxPair>
                <CheckLabel>{option.label}</CheckLabel>
              </CheckWrap>
            ))}
          </Wrap>
        </FilterDropdown>
      )}
    </FilterWrap>
  )
})
